'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _starRating = require('star-rating');

var _svgIcon = require('../../../svg-icon');

var _reactBootstrap = require('react-bootstrap');

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nhsIcon = require('../../src/img/nhs.png');

var InfoSection = function InfoSection(props) {
  var subspecialties = props.subspecialties,
      professionalRegistry = props.professionalRegistry,
      languages = props.languages,
      peerRecommendations = props.peerRecommendations,
      specialty = props.specialty,
      consultationFees = props.consultationFees,
      practices = props.practices,
      active = props.active,
      peerRecommendationsLinkClicked = props.peerRecommendationsLinkClicked,
      isCore = props.isCore;

  return _react2.default.createElement(
    'div',
    { className: (active ? _style2.default.activeSpecialistSection : '') + ' ' + _style2.default.info },
    _react2.default.createElement(
      'h2',
      null,
      'Info'
    ),
    subspecialties && subspecialties.length !== 0 || professionalRegistry && professionalRegistry.length !== 0 || languages || peerRecommendations && peerRecommendations.length !== 0 ? _react2.default.createElement(
      'div',
      { className: _style2.default.leftColumn },
      subspecialties.length === 0 ? null : _react2.default.createElement(
        'div',
        { className: _style2.default.subspecialtiesSection },
        _react2.default.createElement(
          'div',
          { className: _style2.default.block },
          _react2.default.createElement(
            'h3',
            null,
            'SUBSPECIALTIES'
          ),
          subspecialties.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: 'subspeciality' + index,
                className: _style2.default.subspecialties },
              item.name
            );
          })
        )
      ),
      professionalRegistry && professionalRegistry.length !== 0 && _react2.default.createElement(
        'div',
        { className: _style2.default.registeredWithSection },
        _react2.default.createElement(
          'div',
          { className: _style2.default.block },
          _react2.default.createElement(
            'h3',
            null,
            'REGISTERED WITH'
          ),
          professionalRegistry.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: 'registry' + index,
                className: _style2.default.professionalRegistry },
              item.body,
              ': ',
              item.registrationNumber
            );
          })
        )
      ),
      languages ? _react2.default.createElement(
        'div',
        { className: _style2.default.languageSection },
        _react2.default.createElement(
          'div',
          { className: _style2.default.block },
          _react2.default.createElement(
            'h3',
            null,
            'LANGUAGES'
          ),
          _react2.default.createElement('div', { className: _style2.default.textBlock + ' ' + _style2.default.languages,
            dangerouslySetInnerHTML: { __html: (0, _sanitizeHtml2.default)(languages) } })
        )
      ) : null,
      isCore && peerRecommendations && peerRecommendations.length !== 0 && _react2.default.createElement(
        'div',
        { className: _style2.default.recommendedSection },
        _react2.default.createElement(
          'div',
          { className: _style2.default.block },
          _react2.default.createElement(
            'h3',
            null,
            'RECOMMENDED FOR'
          ),
          _react2.default.createElement(
            'a',
            {
              className: _style2.default.recommendedSectionPeerLink,
              onClick: peerRecommendationsLinkClicked
            },
            _react2.default.createElement(
              'div',
              { className: _style2.default.peerBadge },
              _react2.default.createElement(_svgIcon.SvgIcon, {
                className: _style2.default.circleIcon,
                icon: 'peer_recommendation'
              }),
              _react2.default.createElement(
                'span',
                {
                  className: _style2.default.peerRecommendationsBadge },
                peerRecommendations.length
              )
            ),
            _react2.default.createElement(
              'p',
              { className: _style2.default.recommendedSpecialty },
              specialty
            )
          )
        )
      )
    ) : null,
    _react2.default.createElement(
      'div',
      { className: _style2.default.rightColumn },
      practices && practices.length > 0 && practices.filter(function (practice) {
        return practice && practice.id && (practice.status === 'approved' || practice.status === 'verified');
      }).length > 0 && _react2.default.createElement(
        'div',
        { className: _style2.default.practiceSection },
        _react2.default.createElement(
          'div',
          { className: _style2.default.block },
          _react2.default.createElement(
            'h3',
            null,
            'PRACTICES'
          ),
          practices.filter(function (practice) {
            return practice && practice.id && (practice.status === 'approved' || practice.status === 'verified');
          }).map(function (practice, index) {
            return _react2.default.createElement(
              'div',
              { key: 'practice' + index },
              _react2.default.createElement(
                'div',
                { className: _style2.default.practices },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('i', { className: _style2.default.greenIcon + ' ion-android-home' }),
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.practiceName },
                    practice.name,
                    ' ',
                    practice.isNhs && _react2.default.createElement('img', { className: _style2.default.nhsIcon, src: nhsIcon, alt: 'NHS' })
                  ),
                  practice.insurers && practice.insurers.length > 0 && _react2.default.createElement(
                    'ul',
                    { className: _style2.default.practiceInsurers },

                    // not show Consultant Select badge under practice
                    practice.insurers.filter(function (i) {
                      return i.id !== 29;
                    }).map(function (insurer) {
                      return _react2.default.createElement(
                        'li',
                        {
                          key: insurer.id,
                          className: _style2.default.practiceInsurersItem
                        },
                        _react2.default.createElement(
                          _reactBootstrap.OverlayTrigger,
                          {
                            placement: 'top',
                            overlay: _react2.default.createElement(
                              _reactBootstrap.Tooltip,
                              {
                                id: practice.id + '-' + insurer.id,
                                className: 'practice-insurer-tooltip'
                              },
                              insurer.description
                            )
                          },
                          _react2.default.createElement(
                            'span',
                            null,
                            insurer.name
                          )
                        )
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: _style2.default.practiceAddress },
                    practice.street1,
                    practice.street1 && ', ' || '',
                    practice.city,
                    practice.city && ', ' || '',
                    practice.postcode
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.practiceRating },
                    _react2.default.createElement(_starRating.StarRating, { averageRating: practice.averageRating }),
                    _react2.default.createElement(
                      'span',
                      { className: _style2.default.practiceReview },
                      practice.reviewsCount + ' review' + (practice.reviewsCount !== 1 && 's' || '')
                    )
                  )
                )
              )
            );
          })
        )
      )
    )
  );
};

InfoSection.propTypes = {
  subspecialties: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
    name: require('react').PropTypes.string
  })),
  professionalRegistry: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
    body: require('react').PropTypes.string,
    registration_number: require('react').PropTypes.string
  })),
  languages: require('react').PropTypes.string,
  peerRecommendations: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
    review: require('react').PropTypes.string,
    author_name: require('react').PropTypes.string,
    author_profile_image: require('react').PropTypes.string,
    review_date: require('react').PropTypes.string,
    specialty: require('react').PropTypes.string,
    conditions: require('react').PropTypes.string,
    procedures: require('react').PropTypes.string,
    connection: require('react').PropTypes.string
  })),
  specialty: require('react').PropTypes.string,
  consultationFees: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
    fee: require('react').PropTypes.string,
    consultation: require('react').PropTypes.string
  })),
  practices: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
    postcode: require('react').PropTypes.string,
    street1: require('react').PropTypes.string,
    city: require('react').PropTypes.string,
    name: require('react').PropTypes.string,
    practiceUri: require('react').PropTypes.string
  })),
  active: require('react').PropTypes.bool,
  peerRecommendationsLinkClicked: require('react').PropTypes.func,
  isCore: require('react').PropTypes.bool
};
InfoSection.displayName = 'InfoSection';

InfoSection.defaultProps = {
  subspecialties: '',
  registeredWith: [],
  languages: '',
  recommendedFor: '',
  consultationFees: [],
  practices: []
};

exports.default = (0, _reactIntl.injectIntl)(InfoSection);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/info-section.js